var TypedError = require('error/typed');

let InvalidArgumentError = TypedError({
  type: 'argument',
  message: 'Argument error:{msg}',
  msg: null,
  code: null,
});

export default InvalidArgumentError;
